import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useIntl } from 'react-intl';
import { IconButton } from '@americanexpress/dls-react';
import { IconInfo } from '@americanexpress/dls-icons';
import TravelerInfoModal from '../TravelerInfoModal/TravelerInfoModal';
import { getIsTravelerModalOpen } from '../../selectors/formSelectors';
import { setIsTravelerModalClose, setIsTravelerModalOpen } from '../../ducks/formDuck';

const TravelerTooltip = ({ isModalOpen, openModal, closeModal }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <IconButton
        screenReaderLabel={formatMessage({ id: 'filterTooltip.ariaLabel' })}
        shape="round"
        variant="tertiary"
        element="hotel_travelers"
        id="searchHotelNumTravelersTip"
        onClick={openModal}
        reactlytics={{
          element: 'searchHotelNumTravelers',
        }}
      >
        <IconInfo style={{ width: '1rem' }} />
      </IconButton>
      <TravelerInfoModal shown={isModalOpen} onClose={closeModal} />
    </>
  );
};

TravelerTooltip.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export { TravelerTooltip as TestableTravelerTooltip };

export const mapStateToProps = createStructuredSelector({
  isModalOpen: getIsTravelerModalOpen,
});

const mapDispatchToProps = {
  openModal: setIsTravelerModalOpen,
  closeModal: setIsTravelerModalClose,
};

const hocChain = compose(connect(mapStateToProps, mapDispatchToProps));

export default hocChain(TravelerTooltip);
